/**
 * A labelled input.
 *
 * The label is a real <label> bound by id, the hint is wired through
 * aria-describedby, and the focus ring is the browser's own, made visible in
 * the stylesheet rather than removed.
 */

import { useId, type InputHTMLAttributes } from 'react'

interface FieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label: string
  hint?: string | undefined
}

export function Field({ label, hint, ...input }: FieldProps) {
  const id = useId()
  const hintId = `${id}-hint`

  return (
    <div className="field">
      <label className="field__label" htmlFor={id}>
        {label}
      </label>
      <input
        {...input}
        id={id}
        className="field__input"
        aria-describedby={hint ? hintId : undefined}
      />
      {hint ? (
        <p className="field__hint" id={hintId}>
          {hint}
        </p>
      ) : null}
    </div>
  )
}
